/* SAGUIR — aparición suave al hacer scroll y zoom-reveal. Respeta prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  var io = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  function stagger(list) {
    list.forEach(function (el, i) {
      el.style.setProperty('--saguir-delay', Math.min(i % 4, 3) * 0.08 + 's');
    });
  }

  function prepare(root) {
    var vh = window.innerHeight || 800;

    // Zoom-reveal en imágenes de colecciones (siempre, también sobre el pliegue)
    var zooms = Array.prototype.slice.call(root.querySelectorAll('.collection-list .media:not(.saguir-zoom)'));
    stagger(zooms);
    zooms.forEach(function (el) {
      el.classList.add('saguir-zoom');
      if (el.getBoundingClientRect().top < vh * 0.9) {
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            el.classList.add('is-in');
          });
        });
      } else {
        io.observe(el);
      }
    });

    // Aparición suave (solo elementos por debajo del pliegue: lo visible al cargar no se oculta)
    var targets = Array.prototype.slice.call(
      root.querySelectorAll(
        '.product-grid > .grid__item:not(.saguir-reveal), .multicolumn-list__item:not(.saguir-reveal), .rich-text__blocks:not(.saguir-reveal), .image-with-text__grid:not(.saguir-reveal), .saguir-about__inner:not(.saguir-reveal), .saguir-reflexion:not(.saguir-reveal)'
      )
    );
    var below = targets.filter(function (el) {
      return el.getBoundingClientRect().top > vh * 0.92;
    });
    stagger(below);
    below.forEach(function (el) {
      el.classList.add('saguir-reveal');
      io.observe(el);
    });
  }

  function init() {
    prepare(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Editor de temas: reaplicar al recargar una sección
  document.addEventListener('shopify:section:load', function (event) {
    prepare(event.target);
  });
})();
